import { createSelector } from '@reduxjs/toolkit'

export const allControls = state => state.controls

export const selectedTab = createSelector([allControls], controls => {
    return controls ? controls.selectedTab : 0
})